import { motion } from "framer-motion";
import { PhoneMockup } from "@/components/lunar/PhoneMockup";
import { StoreButtons } from "@/components/lunar/StoreButtons";

const EASE = [0.22, 1, 0.36, 1];

export const NetworkingHero = () => (
    <section className="mx-auto max-w-6xl px-6 pb-20 pt-16 sm:pt-20" data-testid="networking-hero">
        <div className="grid items-center gap-14 lg:grid-cols-[1.05fr_0.95fr] lg:gap-8">
            <div>
                <motion.p
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, ease: EASE }}
                    data-testid="networking-hero-pill"
                    className="inline-block rounded-full border border-[#899B6A] px-4 py-1.5 text-[11px] font-medium uppercase tracking-[0.24em] text-[#4A5D23]"
                >
                    Lunar Networking
                </motion.p>
                <h1
                    data-testid="networking-hero-heading"
                    className="font-display mt-6 text-[2.6rem] font-medium leading-[1.06] tracking-tight text-[#1D201A] sm:text-6xl"
                >
                    {["The right person might", "already be in the room."].map((line, i) => (
                        <span key={i} className="block overflow-hidden pb-1">
                            <motion.span
                                className="block"
                                initial={{ y: "112%" }}
                                animate={{ y: "0%" }}
                                transition={{ duration: 0.9, delay: 0.15 + i * 0.13, ease: EASE }}
                            >
                                {i === 1 ? (
                                    <>
                                        already be <em className="italic text-[#4A5D23]">in the room</em>.
                                    </>
                                ) : (
                                    line
                                )}
                            </motion.span>
                        </span>
                    ))}
                </h1>
                <motion.div
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, delay: 0.55, ease: EASE }}
                >
                    <p
                        data-testid="networking-hero-subheading"
                        className="mt-7 max-w-xl text-lg leading-relaxed text-[#3E413B]"
                    >
                        Tell Lunar what you do and who you’d like to meet. Browse who’s around, or
                        let Lunar quietly spot relevant people for you.
                    </p>
                    <div className="mt-9">
                        <StoreButtons
                            appStoreTestId="networking-hero-app-store"
                            googlePlayTestId="networking-hero-google-play"
                        />
                    </div>
                </motion.div>
            </div>
            <motion.div
                initial={{ opacity: 0, y: 32 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.9, delay: 0.4, ease: EASE }}
                className="flex justify-center lg:justify-end"
            >
                <PhoneMockup
                    src="/assets/screens/networking-home-lunar.webp"
                    alt="Lunar Network app — add what you do, then check in at a professional place"
                    testId="networking-hero-phone"
                    eager
                />
            </motion.div>
        </div>
    </section>
);
